export default {
    "modelClassTypeId": "COUPE",
    "modelClassId": "401",
    "carModelDetailList": [
        {
            "carModelId": "G550L",
            "colorList": [
                {
                    "color": "197",
                    "colorName": "0883923230",
                    "colorImage": "http://13.250.199.219/mbfjwebadmin/uploadFiles/20180525_031641_c-class_c_180_BlueEFFICIENCY_header.jpg",
                    "trimList": [
                        {
                            "trim": "501",
                            "trimName": "name 501",
                            "trimImage": "http://13.250.199.219/mbfjwebadmin/uploadFiles/20180525_031643_C-Class_c204.jpg",
                            "optionList": [
                                {
                                    "carModelList": [
                                        {
                                            "id": "9cc120ec-0ebf-4ea9-92d4-5869fb5d1e73",
                                            "commission": "0883923230",
                                            "yearReleased": 2018,
                                            "msrp": 15300000,
                                            "monthlyLeasingFee": 173600,
                                            "coverImage": "http://13.250.199.219/mbfjwebadmin/uploadFiles/20180525_031640_c_class1.jpg"
                                        }
                                    ],
                                    "option": "ZG6,ZT1,"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ]
}


// WEBPACK FOOTER //
// ./src/mock_apis/model-detail-data.js